<template>
  <div class="u-16">
    <div class="u grid between cross-center ver-padding-20">
      <h2 class="u">Сработавшие правила АФ</h2>
    </div>

    <b-table
      :data="afruleList"
      mobile-cards
      striped
      :default-sort="[sortField, sortOrder]"
      :default-sort-direction="defaultSortOrder"
      class="u-16 afrules"
    >
      <template slot-scope="props" slot="header">{{ props.column.label }}</template>

      <template slot-scope="props" slot="default">
        <b-table-column
          field="date_created"
          label="Дата"
          sortable
          width="180"
        >{{ props.row.date_created | momentFormat() }}</b-table-column>
        <b-table-column field="rule_id" label="Правило">{{ afruleName(props.row.rule_id) }}</b-table-column>
        <b-table-column field="matched" label="Сработало">
          <i class="el-icon-check" v-if="props.row.matched == true"></i>
          <i class="el-icon-minus danger" v-else></i>
        </b-table-column>
      </template>
    </b-table>
  </div>
</template>

<script>
import axios from "axios";
import Vuex from "vuex";
import { mapGetters } from "vuex";
import { _ } from "underscore";
import VueAxios from "vue-axios";
export default {
  name: "AntifraudRules",
  props: ["afruleList"],
  data() {
    return {
      isShow: true,
      isFull: false,
      sortField: "Date",
      sortOrder: "desc",
      defaultSortOrder: "desc"
    };
  },
  methods: {},
  computed: {
    ...mapGetters(["afruleName"])
  }
};
</script>

<style lang="sass">

</style>